export function manufacturerSearchText(value: string): string {
  return value.toLocaleLowerCase("ru")
    .replace(/терм[ао]люкс|термо\s*люкс/g, "termo lux")
    .replace(/алют[еэ]кс/g, "alutex").replace(/гевисс/g, "geviss")
    .replace(/грайн/g, "grain").replace(/лидер/g, "lider")
    .replace(/престиж/g, "prestige").replace(/премиум/g, "premium")
    .replace(/вектор/g, "vektor").replace(/нордпроф/g, "nordprof")
    .replace(/булава/g, "bulava").replace(/декор/g, "dekor")
    .replace(/\s+/g, "");
}
